import { getFirebaseDb } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

export async function getFollowing(userId: string) {
    try {
        const db = await getFirebaseDb();
        const snapshot = await getDocs(collection(db, 'users', userId, 'following'));
        return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.error('Failed to get following:', error);
        return [];
    }
}
